<template>
  <v-sheet elevation="2" class="px-12 py-8 rounded white">
    <div class="mb-6">
      <p class="h6 pa-0 mb-0">
        {{ $t('auth.lost_password.change_password') }}
      </p>
    </div>
    <v-form v-model="formIsValid" v-on:submit.prevent ref="password">
      <PasswordField
        class="mb-6"
        :disabled="isLoading"
        :password="form.currentPassword"
        :passwordRules="[
          p => !!p || $t('validation.form.this_field_is_required'),
        ]"
        :label="`${$t('auth.current_password')}*`"
        @onChange="handlePasswordChange({ currentPassword: $event })"
      />
      <AddPassword
        :password="form.password"
        :confirmPassword="form.confirmPassword"
        :isLoading="isLoading"
        @change="handlePasswordChange"
      />
      <div class="mt-6 text-right">
        <Button
          color="primary"
          size="large"
          data-testid="profile-button-save"
          :disabled="isLoading || !formIsValid"
          :text="$t('auth.lost_password.change_password')"
          @click.prevent="updatePassword"
        />
      </div>
    </v-form>
  </v-sheet>
</template>
<script>
import mixin from '@/mixins/mixin.vue'
import passwordMixin from '@/mixins/passwordMixin.vue'
import Button from '@/components/UI/Button'
import PasswordField from '@/components/PasswordField.vue'
import AddPassword from '@/components/AddPassword.vue'

export default {
  name: 'ChangePassword',

  mixins: [mixin, passwordMixin],

  components: {
    Button,
    PasswordField,
    AddPassword,
  },

  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    onUpdate: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      form: {
        currentPassword: '',
        password: '',
        confirmPassword: '',
      },
      formIsValid: true,
      showCurrentPassword: false,
    }
  },

  methods: {
    handlePasswordChange(password) {
      this.form = { ...this.form, ...password }
    },

    async updatePassword() {
      const isUpdated = await this.onUpdate({
        previousPassword: this.form.currentPassword,
        newPassword: this.form.password,
      })
      this.form.currentPassword = ''
      if (!isUpdated) return
      this.form.password = ''
      this.form.confirmPassword = ''
      this.$refs.password.reset()
    },
  },
}
</script>
